var map = {
	"./Ca-T200.gif": "11ce",
	"./Ca-T600.gif": "7eda",
	"./Ca-studio.gif": "ba61",
	"./ChSimplified-T200.gif": "9b0e",
	"./ChSimplified-T600.gif": "27fb",
	"./ChSimplified-studio.gif": "86d1",
	"./ChTradicional-T200.gif": "424b",
	"./ChTradicional-T600.gif": "33ac",
	"./ChTradicional-studio.gif": "1f76",
	"./De-T200.gif": "888c",
	"./De-T600.gif": "9c5c",
	"./De-studio.gif": "c8cb",
	"./En-Studio.gif": "8bd4",
	"./En-T200-T600.gif": "080e",
	"./En-T200.gif": "32f6",
	"./En-T600.gif": "f9ff",
	"./End_screen.gif": "9a84",
	"./Es-T200.gif": "0679",
	"./Es-T600.gif": "9bb2",
	"./Es-studio.gif": "845d",
	"./Fr-T200.gif": "9e94",
	"./Fr-T600.gif": "7968",
	"./Fr-studio.gif": "d887",
	"./It-T200.gif": "96e5",
	"./It-T600.gif": "d2f2",
	"./It-studio.gif": "dd62",
	"./Ja-T200.gif": "e42b",
	"./Ja-T600.gif": "4cf0",
	"./Ja-studio.gif": "8e2f",
	"./Ko-T200.gif": "1d4c",
	"./Ko-T600.gif": "74c6",
	"./Ko-studio.gif": "65d1",
	"./Last image OOBE English.png": "d958",
	"./Last image OOBE French.png": "9c28",
	"./Last image OOBE German.png": "d11b",
	"./Last image OOBE Italian.png": "2f44",
	"./Last image OOBE Japanese.png": "b83e",
	"./Last image OOBE Korean.png": "ce76",
	"./Last image OOBE Polish.png": "ef2b",
	"./Last image OOBE Portuguese.png": "71f5",
	"./Last image OOBE Simplified Chinese.png": "93e1",
	"./Last image OOBE Spanish.png": "492d",
	"./Last image OOBE Traditional Chinese.png": "2be6",
	"./Nl-Studio.gif": "52c82",
	"./Nl-T200.gif": "16e7",
	"./Nl-T600.gif": "90af",
	"./Pl-T200.gif": "c177",
	"./Pl-T600.gif": "b39a",
	"./Pl-studio.gif": "3aa7",
	"./Pt-T200.gif": "0f71",
	"./Pt-T600.gif": "4065",
	"./Pt-studio.gif": "12c1",
	"./Ru-T200.gif": "dccb",
	"./Ru-T600.gif": "fb78",
	"./Ru-studio.gif": "3df7",
	"./Web_App_Spanish_image.png": "35ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e41";